// Behavior shared by every prompt field (home hero, /explore hero, /create
// intro), the way app/utils/prompt_length.ts shares the limits and
// components/_prompt_field.scss the skin. The card is what reads as the field,
// so it has to take the caret, and the textarea grows with its content.

// The stylesheet's max-height caps the growth; past it the textarea scrolls.
export const fitPromptHeight = (input: HTMLTextAreaElement) => {
  input.style.height = "auto"
  input.style.height = `${input.scrollHeight}px`
}

// Wires a card and its textarea: a click on the card outside the input (its
// padding, the count) lands the caret in the input, while controls inside the
// card keep their own click; the height follows the content and viewport
// reflows. Returns the teardown.
export const wirePromptField = (card: HTMLElement | null, input: HTMLTextAreaElement): (() => void) => {
  const onCardClick = (event: MouseEvent) => {
    const target = event.target as HTMLElement
    if (target === input || target.closest("button, a")) return
    input.focus()
  }
  const onResize = () => fitPromptHeight(input)

  card?.addEventListener("click", onCardClick)
  window.addEventListener("resize", onResize)
  fitPromptHeight(input)

  return () => {
    card?.removeEventListener("click", onCardClick)
    window.removeEventListener("resize", onResize)
  }
}
